import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { InitialsMonogramComponent } from './initials-monogram/initials-monogram.component';
import { MatButtonModule } from '@angular/material/button';
import { MessageReplyComponent } from './message-reply/message-reply.component';
import { relativeDate, userFullName } from './message-helpers';
import { AddMessageReplyComponent } from './add-message-reply/add-message-reply.component';
import { FromRole, Message } from '@app/app/interfaces/message.model';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AddMessageReplyComponent,
    InitialsMonogramComponent,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule,
    MessageReplyComponent,
  ],
})
export class MessageComponent {
  message = input.required<Message>();
  dealId = input.required<number>();
  index = input.required<number>();
  messageIdToHighlight = input<number>();
  replyIdToHighlight = input<number>();

  repliesAreVisible = signal(false);
  replyInputIsVisible = signal(false);

  highlightMessageEffect = effect(() => {
    const messageIdToHighlight = this.messageIdToHighlight();
    if (messageIdToHighlight && !this.replyIdToHighlight()) {
        this.scrollMessageOrReplyIntoView(`[data-message-id="${messageIdToHighlight}"]`);
    }
  });
  hightlightReplyEffect = effect(() => {
    const replyIdToHighlight = this.replyIdToHighlight();
    if (replyIdToHighlight) {
      this.repliesAreVisible.set(true);
      this.scrollMessageOrReplyIntoView(`[data-reply-id="${replyIdToHighlight}"]`);
    }
  });

  readonly FromRole = FromRole;
  readonly relativeDate = relativeDate;
  readonly userFullName = userFullName;

  constructor() {}

  handleReplyAdded(): void {
    this.repliesAreVisible.set(true);
    this.replyInputIsVisible.set(false);
  }

  scrollMessageOrReplyIntoView(selector: string): void {
    // Wait for next tick when DOM will have messages and replies
    setTimeout(() => {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center'});
      }
    });
  }
}
